import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Container,
  Input,
  Label,
  Progress,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import { Option } from "api/types/_public";
import UploadImageSingle from "components/Common/UploadImageSingle";
import UploadImage from "components/Common/UploadImage";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  COLOR_BAR_REVIEW_TYPE,
  LIST_OPTION_BAR_REVIEW_TYPE,
} from "helpers/constans";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import { postComment, putComment } from "store/winkComment/thunk";
import NO_IMAGE from "../../../../assets/images/users/ic_defaul_avatar2.png";

export interface Props {
  winkId: string;
  id?: string;
  triggerRefresh?: () => void;
  isCloseModal?: any;
  rowSelected?: any;
  isEditModal?: boolean;
  LIST_OPTION_BAR_DETAIL_REVIEW_STAR_RATING_LANG?: Option[];
  setLinkImage?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const CommentForm = ({
  winkId = "",
  triggerRefresh,
  isCloseModal,
  rowSelected,
  setLinkImage,
}: Props) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false);
  const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);
  const [isFirstProgressUpdate, setIsFirstProgressUpdate] =
    useState<boolean>(true);
  const [userSearch, setUserSearch] = useState<any>(null);

  const id = rowSelected?.id;

  const handleSubmit = async (values: any) => {
    try {
      isCloseModal && isCloseModal();
      setIsLoading((_prev) => true);

      const formatFile =
        values?.files?.length > 0
          ? values?.files?.map((item: any) => item?.url)
          : null;

      let data: any = {
        post_id: winkId,
        comment: values?.comment,
        files: values?.files,
        ...(values?.user_id
          ? { user_id: values?.user_id }
          : {
              commenter_email: values?.commenter_email,
              commenter_nickname: values?.commenter_nickname,
              commenter_avatar: values?.commenter_avatar,
            }),
      };

      if (id) {
        data = {
          comment: data.comment,
          files: values?.files,
        };
      }

      const response: any = id
        ? await putComment(id, data)
        : await postComment(data);

      if (response?.code === 200) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    comment: Yup.string().required(`${t("This field is required")}`),
    user_id: Yup.string().when("source_comment", {
      is: (value: any) => !value,
      then: (rule) => {
        return rule.test(
          "source_comment",
          `${t("This field is required")}`,
          (target) => !!target
        );
      },
    }),
    commenter_nickname: Yup.string().when("source_comment", {
      is: (value: any) => !!value,
      then: (rule) => {
        return rule.test(
          "source_comment",
          `${t("This field is required")}`,
          (target) => !!target
        );
      },
    }),
    commenter_email: Yup.string()
      .email(`${t("Email format is incorrect")}`)
      .matches(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        `${t("Email format is incorrect")}`
      )
      .when("source_comment", {
        is: (value: any) => !!value,
        then: (rule) => {
          return rule.test(
            "source_comment",
            `${t("This field is required")}`,
            (target) => !!target
          );
        },
      }),
    // commenter_avatar: Yup.string().when('source_comment', {
    //   is: (value: any) => !!value,
    //   then: (rule) => {
    //     return rule.test('source_comment', `${t("This field is required")}`, (target) => !!target)
    //   },
    // }),
  });

  const formik = useFormik({
    initialValues: {
      source_comment: LIST_OPTION_BAR_REVIEW_TYPE?.[1]?.value,
      comment: "",
      commenter_nickname: "",
      commenter_email: "",
      commenter_avatar: "",
      user_id: "",
      files: null,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleSetValueForm = (valueDefault: any) => {
    formik.setFieldValue("post_id", valueDefault?.post_id || "");
    formik.setFieldValue("source_comment", valueDefault?.is_seeding);
    formik.setFieldValue("comment", valueDefault?.comment || "");
    formik.setFieldValue("files", valueDefault?.files || null);

    if (valueDefault?.user_id) {
      setUserSearch({
        value: String(valueDefault?.user_profile?.user_id),
        label: (
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                height: "22px",
                width: "22px",
                minWidth: "22px",
                overflow: "hidden",
                borderRadius: "15px",
                objectFit: "cover",
                backgroundColor: "#eaeaea",
                zIndex: 99,
              }}
            >
              <img
                src={valueDefault?.user_profile?.profile_image_url || NO_IMAGE}
                alt={valueDefault?.user_profile?.nickname}
                height={22}
                width={22}
                style={{
                  minWidth: "22px",
                  overflow: "hidden",
                  borderRadius: "50%",
                  objectFit: "cover",
                  backgroundColor: "#eaeaea",
                }}
              />
            </div>
            <div>{`${
              valueDefault?.user_profile?.nickname
                ? valueDefault?.user_profile?.nickname + " -"
                : ""
            } ${valueDefault?.user_profile?.email}`}</div>
          </div>
        ),
        data: valueDefault?.user_profile,
      });
      formik.setFieldValue("user_id", valueDefault?.user_id || "");
    } else {
      formik.setFieldValue(
        "commenter_nickname",
        valueDefault?.user_profile?.nickname || ""
      );
      formik.setFieldValue(
        "commenter_email",
        valueDefault?.user_profile?.email || ""
      );
      formik.setFieldValue(
        "commenter_avatar",
        valueDefault?.user_profile?.profile_image_url || ""
      );
    }
  };

  useEffect(() => {
    if (rowSelected) {
      handleSetValueForm(rowSelected);
    }
  }, [rowSelected]);

  useEffect(() => {
    document.title = `${t("Review")} - ${t("Bar Detail")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]);

  return (
    <React.Fragment>
      <div>
        <Container fluid className="px-0">
          <div className="mb-4">
            <Progress
              value={
                isFirstProgressUpdate && id
                  ? 100
                  : !isFirstProgress || !!id
                  ? 100 - (100 / 5) * Number(Object.keys(formik.errors).length)
                  : 0
              }
              color="primary"
              className="animated-progress progress-sm"
            />
          </div>
          <form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xxl={formik.values.source_comment === 1 ? 4 : 6}>
                <div className="mb-3">
                  <label className="form-label">
                    {t("Type")}{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <DropdownStatusNew
                    name="source_comment"
                    dataList={LIST_OPTION_BAR_REVIEW_TYPE || []}
                    placeholder={`${t("Type")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.source_comment}
                    onChangeSelect={(event: any) => {
                      formik.setFieldTouched("source_comment", true);
                      formik.setFieldValue("source_comment", event?.value);
                    }}
                    isHasOptionAll={false}
                    colors={COLOR_BAR_REVIEW_TYPE}
                    disabled={!!id}
                  />
                  {formik.touched.source_comment &&
                  formik.errors.source_comment ? (
                    <div className="text-danger mt-2">
                      {formik.errors.source_comment}
                    </div>
                  ) : null}
                </div>
              </Col>

              {formik.values.source_comment === 0 ? (
                <Col xxl={6}>
                  <div className="mb-3">
                    <label className="form-label">
                      {t("Users")} <span className="text-danger"> *</span>
                    </label>

                    <DropdownAsyncUsers
                      name="user_id"
                      onChangeSelect={(event: any) => {
                        setUserSearch(event);
                        formik.setFieldTouched("user_id", true);
                        formik.setFieldValue("user_id", event?.value);
                      }}
                      isMulti={false}
                      placeholder={`${t("Select User")}...`}
                      isShowIconCheck={false}
                      isAllOption={true}
                      listCheckedUsers={userSearch}
                      paramsTypeUsers={1}
                      defaultParams={{ is_guest: "0", is_active: 1 }}
                      isClearable={false}
                      isShowAvatar={true}
                      isDisabled={!!id}
                    />

                    {formik.touched.user_id && formik.errors.user_id ? (
                      <div className="text-danger mt-2">
                        {formik.errors.user_id}
                      </div>
                    ) : null}
                  </div>
                </Col>
              ) : (
                <>
                  <Col xxl={4}>
                    <div className="mb-3">
                      <label className="form-label">
                        {t("Nickname")} <span className="text-danger"> *</span>
                      </label>
                      <Input
                        name="commenter_nickname"
                        type="text"
                        className="form-control"
                        id="nameInput"
                        placeholder={t("Enter your nickname")}
                        value={formik?.values?.commenter_nickname}
                        disabled={!!id}
                        onChange={(event: any) => {
                          formik.setFieldTouched("commenter_nickname", true);
                          formik.setFieldValue(
                            "commenter_nickname",
                            event?.target?.value
                          );
                        }}
                      />
                      {formik.touched.commenter_nickname &&
                      formik.errors.commenter_nickname ? (
                        <div className="text-danger mt-2">
                          {formik.errors.commenter_nickname}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col xxl={4}>
                    <div className="mb-3">
                      <label className="form-label">{t("Email")}</label>{" "}
                      <span className="text-danger">*</span>
                      <Input
                        name="commenter_email"
                        type="text"
                        className="form-control"
                        id="nameInput"
                        placeholder={t("Enter your email")}
                        disabled={!!id}
                        value={formik?.values?.commenter_email}
                        onChange={(event: any) => {
                          formik.setFieldTouched("commenter_email", true);
                          formik.setFieldValue(
                            "commenter_email",
                            event?.target?.value
                          );
                        }}
                      />
                      {formik.touched.commenter_email &&
                      formik.errors.commenter_email ? (
                        <div className="text-danger mt-2">
                          {formik.errors.commenter_email}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="mb-3">
                      <Label htmlFor="imageInput" className="form-label">
                        {t("Avatar")}
                      </Label>
                      <UploadImageSingle
                        data={formik.getFieldProps("commenter_avatar")?.value}
                        setLinkImage={null}
                        formik={formik}
                        isMultiple={false}
                        isDisabled={!!id}
                        uploadProps={{
                          name: "files",
                          accept: "image/png,image/jpeg,image/*",
                          beforeUpload: () => false,
                          headers: {
                            authorization: "authorization-text",
                          },
                        }}
                        formikNameImage={"commenter_avatar"}
                      />
                    </div>
                  </Col>
                </>
              )}

              <Col xxl={12} className="date-picker-wrapper-custom mt-3 mt-md-2">
                <div className="mb-3">
                  <Label className="form-label">{t(`Comment`)}</Label>{" "}
                  <span className="text-danger"> *</span>
                  <textarea
                    className="form-control"
                    id="comment"
                    name="comment"
                    value={formik?.values?.comment}
                    placeholder={`${t("Comment")}...`}
                    onChange={(event: any) => {
                      setIsFirstProgressUpdate(false);
                      formik.setFieldTouched("commenter_email", true);
                      formik.setFieldValue(
                        "comment",
                        event?.target?.value || ""
                      );
                    }}
                    style={{ height: 150 }}
                  />
                  {formik.touched.comment && formik.errors.comment ? (
                    <div className="text-danger mt-2">
                      {formik.errors.comment}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="imageInput" className="form-label">
                    {t("Images")}
                  </Label>
                  <UploadImage
                    data={formik.getFieldProps("files")?.value}
                    setLinkImage={setLinkImage}
                    formik={formik}
                    isMultiple={true}
                    uploadProps={{
                      name: "files",
                      accept: "image/png,image/jpeg,image/*",
                      beforeUpload: () => false,
                      headers: {
                        authorization: "authorization-text",
                      },
                    }}
                    formikNameImage={"files"}
                    isListURLString={true}
                  />
                </div>
              </Col>

              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  <button
                    className="btn btn-primary fs-14"
                    color="success"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <Spinner size="sm" className="me-2"></Spinner>
                    ) : (
                      <>{id ? t("Update") : t("Create")}</>
                    )}
                  </button>

                  {/* <button className="btn btn-soft-secondary fs-14" type="button" color="light" onClick={onCloseClick} disabled={isLoading}>
                        <i className="ri-indeterminate-circle-line align-bottom me-1"></i>
                        {t('Button Close')}
                    </button> */}
                </div>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CommentForm;
